import { useEffect, useState } from "react"
import { useMutation } from "react-query"
import { uploadProfilePhoto } from "../../../common/apis/private.api"
import { Avatar } from "../../../common/components/avatar"
import { Button, ButtonFile } from "../../../common/components/controls/button"
import { textChooser } from "../../../common/util/textChooser"
import { convertToBase64 } from "../../../common/helpers/utilities"
import { useUser } from "../../../common/hooks/User"
import "./photoUpload.scss"

export const PhotoUpload = () => {
  const { getDataAll, refreshUserSession } = useUser();
  const { imageUrl, id } = getDataAll();

  const { mutate, isSuccess, isLoading, isError } = useMutation((params: any) =>
    uploadProfilePhoto(params.id, params.body)
  )

  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState<any>();

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  useEffect(() => {
    if (isSuccess) {
      // forcing to upload the newest uploaded image
      // const postfix = (new Date()).getMilliseconds();
      refreshUserSession();

      // setDataByAttributeName("imageUrl", `${data.id}?v=${postfix}`);
      // setSelectedFile(undefined);
    }
  }, [isSuccess]);

  const onSelectFile = (e: any) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }
    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  }

  const handleUploadPhoto = async () => {
    const base64 = await convertToBase64(selectedFile);
    mutate({ id, body: { file: base64 } });
  }

  if (isError) {
    window.alert(textChooser("txt141"));
  }

  return (
    <div className="upload-photo-wrapper">
      <div className="upload-avatar">
        <Avatar
          url={preview ?? imageUrl}
          testId="user-photo"
        />
      </div>
      <div className="upload-controls">
        <ButtonFile
          text={textChooser("txt134")}
          onChange={onSelectFile}
        />

        {selectedFile && (
          <Button
            label={isLoading ? textChooser("txt140") : textChooser("txt133")}
            onClick={handleUploadPhoto}
            disabled={isLoading}
            primary
          />
        )}
      </div>
    </div>
  )
}